/**
 * OVERRIDE AlbumView.jsx
 */

import ListingView from '../../../../components/View/ListingView';

export default ListingView;